import script from "./SetupTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetupTabs.vue?vue&type=script&lang=ts&setup=true"

import "./SetupTabs.vue?vue&type=style&index=0&id=28349f6b&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28349f6b"]])

export default __exports__